'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import { useModalControls, usePermissions } from '../contexts';

import './SecondaryActions.scss';

const SecondaryActions = ({ user, plan, maxOffset, addDay, permissions, clearPlan, duplicatePlan, isDuplicating, isPro }) => {
    const { showGroceries, showNutrition, showProfile } = useModalControls();
    const { canViewNutrition } = usePermissions();

    // Extract repeated conditionals to named constants
    const canModifyPlan = permissions.canWrite || permissions.canCreate;
    const showDuplicateButton = plan?.links?.self; // Only show if plan is saved

    return (
        <div className="secondary-actions">
            <div className="el-toolbar1 el-toolbar1-dark">
                {/* 1. Duplicate Meal Plan Button */}
                {showDuplicateButton && (
                    <button
                        className="el-toolbar-btn duplicate-plan-btn"
                        onClick={duplicatePlan}
                        disabled={isDuplicating}
                        title={isDuplicating ? 'Duplicating meal plan' : 'Duplicate this meal plan'}
                    >
                        <i className="feather feather-copy" />
                        <span>{isDuplicating ? 'Duplicating...' : 'Duplicate Meal Plan'}</span>
                    </button>
                )}

                {/* 2. Add a Day */}
                <button
                    className="el-toolbar-btn add-a-day"
                    onClick={addDay}
                >
                    <i className="feather feather-plus" />
                    <span>Add a Day</span>
                </button>

                {user && (isPro || user.role === 'admin') && (
                    <button
                        className="el-toolbar-btn show-profile-debug"
                        onClick={showProfile}
                        title={user.role === 'admin' ? "Debug profile data and nutrition settings" : "View plan settings"}
                    >
                        <i className="feather feather-eye" />
                        <span>View Plan Settings</span>
                    </button>
                )}

                {/* 4. Preview Grocery List */}
                {user && (
                    <button
                        className="el-toolbar-btn preview-groceries-btn"
                        onClick={showGroceries}
                    >
                        <i className="feather feather-shopping-cart" />
                        <span>Preview Grocery List</span>
                    </button>
                )}

                {/* 5. Clear Meals Button */}
                {canModifyPlan && (
                    <button
                        className="el-toolbar-btn clear-meals-btn"
                        onClick={clearPlan}
                    >
                        <i className="feather feather-trash-2" />
                        <span>Clear Meals</span>
                    </button>
                )}
            </div>

            {/* Mobile heading - only show on mobile */}
            <h4 className="mobile-insights-heading">Daily Avg. Meal Plan Insights</h4>

            {/* View Daily Nutrition Stats - placed below toolbar */}
            {canViewNutrition && (
                <button
                    className="el-medium-btn el-raspberry-outline-btn view-daily-nutrition-btn"
                    onClick={showNutrition}
                >
                    View Daily Nutrition Stats
                </button>
            )}
        </div>
    );
};

SecondaryActions.propTypes = {
    user: PropTypes.shape({
        role: PropTypes.string,
    }).isRequired,
    plan: PropTypes.object,
    maxOffset: PropTypes.number.isRequired,
    addDay: PropTypes.func.isRequired,
    permissions: PropTypes.shape({
        canWrite: PropTypes.bool,
        canCreate: PropTypes.bool,
        canViewNutrition: PropTypes.bool,
    }).isRequired,
    clearPlan: PropTypes.func.isRequired,
    duplicatePlan: PropTypes.func,
    isDuplicating: PropTypes.bool,
    isPro: PropTypes.bool,
};

export default SecondaryActions;
